var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4613 10C17.462 10.2612 17.395 10.5181 17.267 10.7457C17.1389 10.9733 16.9541 11.1639 16.7306 11.299L2.87741 19.7736C2.64385 19.9166 2.37635 19.9947 2.10252 19.9997C1.8287 20.0048 1.55849 19.9367 1.31979 19.8024C1.08337 19.6702 0.886427 19.4775 0.74921 19.2439C0.611993 19.0104 0.539458 18.7445 0.539062 18.4736V1.52637C0.539458 1.2555 0.611993 0.989628 0.74921 0.756089C0.886427 0.52255 1.08337 0.329774 1.31979 0.197586C1.55849 0.063312 1.8287 -0.00480701 2.10252 0.000263782C2.37635 0.00533457 2.64385 0.0834115 2.87741 0.226431L16.7306 8.70102C16.9541 8.83609 17.1389 9.0267 17.267 9.25432C17.395 9.48195 17.462 9.73883 17.4613 10Z",
    fill: "#C06674"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
export default __webpack_public_path__ + "static/media/icon_play.113f90b9f04836db58efca11e21d9310.svg";
export { ForwardRef as ReactComponent };